// providers/practicePanther.ts
import * as Api from '@ViewModels';
import { provider, toggle } from './helpers';

export const practicePantherConfig = provider(Api.IntegrationProvider.PracticePanther, {
	displayName: 'PracticePanther',

	main: {
		writebacks: true,
		fields: [
			toggle('useFirstMappedUserAsOwner', {
				label: 'Use First Mapped User As Owner',
				subtitle:
					'Enable this to determine contact ownership in Levitate by the first mapped source system user (see User Mappings) instead of the first source system user when multiple owners are assigned.',
			}),
		],
	},

	keyFacts: {
		birthdayDisplay: true,
	},

	tags: {
		coreTags: true,
		customFields: true,
		extraFields: [
			toggle('accountTagsEnabled', {
				label: 'Account Tags',
				subtitle: 'Enable automatic tagging of contacts based on their associated accounts',
			}),
			toggle('assignedUsersTagsEnabled', {
				label: 'Assigned Users Tags',
				subtitle: 'Enable automatic tagging of contacts based on assigned users',
			}),
		],
	},
});
